import React from "react";
import { Box } from '@curves/ui-base';
import MeasurementClickableCard from "../Common/MeasurementClickableCard";
import MonitorWeightOutlinedIcon from "@mui/icons-material/MonitorWeightOutlined";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";

const CIDBalanceCards = ({ sourceData, onTrendLineClick }) => {
	return (
		<Box className="measurement-group-content--3">
			<MeasurementClickableCard
				className="measurement-group-content__item"
				name="體重"
				value={sourceData?.weight}
				unit="kg"
				icon={<MonitorWeightOutlinedIcon />}
				onClick={() => onTrendLineClick(sourceData?.weightTrendType)}
			/>
			<MeasurementClickableCard
				className="measurement-group-content__item"
				name="骨骼肌重"
				value={sourceData?.smm}
				unit="kg"
				icon={<FitnessCenterIcon />}
				onClick={() => onTrendLineClick(sourceData?.smmTrendType)}
			/>
			<MeasurementClickableCard
				className="measurement-group-content__item"
				name="體脂肪重"
				value={sourceData?.bfm}
				unit="kg"
				icon={<ScatterPlotIcon />}
				onClick={() => onTrendLineClick(sourceData?.bfmTrendType)}
			/>
		</Box>
	);
};

export default CIDBalanceCards;
